'use client'

import { useTranslations } from 'next-intl'
import { useEffect, useState } from 'react'

import Container from '@/components/ui/Container'

type DescriptionProps = {
  desc: string
}

export default function Description({ desc }: DescriptionProps) {
  const [description, setDescription] = useState<string>(desc || '')
  const [expanded, setExpanded] = useState(false)
  const t = useTranslations('common')

  useEffect(() => {
    setDescription(desc)
  }, [desc])

  const getPreviewText = () => {
    const paragraphs = description.split(/<\/p>/i)
    if (paragraphs.length > 2) {
      return (
        paragraphs.slice(0, 2).join('</p>') +
        `<span class='info-view-more-dot'>..</span><span class='info-view-more ml-1' id='view-more'>${t('view_more')} <i class='tgic icon-chevron-down'></i></span>`
      )
    }
    return description
  }

  const getFullTextWithCollapse = () => {
    const paragraphs = description.split(/<\/p>/i)
    if (paragraphs.length > 2) {
      return (
        paragraphs.slice(0, paragraphs.length - 1).join('</p>') +
        `<span class='info-view-less ml-1' id='view-less'>${t('collapse')} <i class='tgic icon-chevron-up'></i></span></p>`
      )
    }
    return description
  }

  useEffect(() => {
    const viewMoreButton = document.getElementById('view-more')
    const viewLessButton = document.getElementById('view-less')

    if (viewMoreButton) {
      viewMoreButton.addEventListener('click', () => setExpanded(true))
    }

    if (viewLessButton) {
      viewLessButton.addEventListener('click', () => setExpanded(false))
    }

    return () => {
      if (viewMoreButton) {
        viewMoreButton.removeEventListener('click', () => setExpanded(true))
      }

      if (viewLessButton) {
        viewLessButton.removeEventListener('click', () => setExpanded(false))
      }
    }
  }, [description, expanded])

  return (
    <div className="bg-[#f8fafc]">
      <Container>
        <div id="category_desc" dangerouslySetInnerHTML={{ __html: expanded ? getFullTextWithCollapse() : getPreviewText() }} />
      </Container>
    </div>
  )
}
